// Module
var code = "<button class=\"md-button abx-button\"> <i class=\"material-icons md-18\"></i> <ng-transclude></ng-transclude> </button> ";
// Exports
module.exports = code;